import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-filter-toggle',
  templateUrl: './filter-toggle.component.html',
  styleUrls: ['./filter-toggle.component.scss']
})
export class FilterToggleComponent {

  @Input() showAdvanced = false;

  // color type: 'primary' | 'secondary'
  @Input() variant: 'primary' | 'secondary' = 'primary';

  @Output() toggle = new EventEmitter<void>();

  onToggle() {
    this.toggle.emit();
  }
}
